// extracted by mini-css-extract-plugin
export default {"tile":"Tile_tile__0p6wT","loading":"Tile_loading__AX+Mz","text":"Tile_text__QmJeA","tileContent":"Tile_tileContent__4tBWg"};